import React from 'react';
import ReactDOM from 'react-dom/client';
// Estilos de librerías que usan las pantallas. Antes venían solos porque todas las pantallas iban en el archivo
// principal; ahora cada pantalla baja al abrirse, así que se cargan aquí, al inicio y ANTES del tema corporativo
// (sin esto el aviso «Ingreso exitoso» salía sin estilo y una pantalla abierta después podía pisar el tema).
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';
import 'webdatarocks/webdatarocks.css';
// antes que App: las pantallas ya encuentran la caché de listas al pedirlas
import './tema/cacheListas';
import App from './App';
// Tema corporativo (colores, tablas, botones), íconos de línea y manejo con teclado. Van DESPUÉS de App
// para que su CSS quede al final y gane sobre el de las pantallas. Ver src/tema/LEEME.md.
import './tema/tema-corporativo.css';
import './tema/iconos';
import './tema/teclado';
// import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
